export const QUESTION = {
    '1': [
        {
            title: '【紛れる】の正しい読み方は？',
            options: ['あ、まぎれる', 'い、まきれる', 'う、まぐれる'],
            answer: 1
        },
        {
            title: '7-（-2）= ？？？',
            options: ['あ、5', 'い、-5', 'う、9'],
            answer: 3
        },
        {
            title:
        'これは私の叔母からの贈り物です。<br>These is a (???) from my aunt.',
            options: ['あ、letter', 'い、gift', 'う、message'],
            answer: 2
        },
        {
            title: '有機物以外の物質である無機物を選びなさい',
            options: ['あ、食塩', 'い、砂糖', 'う、プラスチック'],
            answer: 1
        },
        {
            title: '室町時代に幕府が置かれていた場所はどこでしょうか？',
            options: ['あ、大阪', 'い、奈良', 'う、京都'],
            answer: 3
        }
    ],
    '2': [
        {
            title: '【紫】という漢字は、何画ですか?',
            options: ['あ、11または12', 'い、13', 'う、14'],
            answer: 1
        },
        {
            title: '（-7）+（-9）=??? ',
            options: ['あ、-2', 'い、-16', 'う、2'],
            answer: 2
        },
        {
            title:
        '私は昨年の夏、ニューヨークで二週間過ごしました。 <br>I (???) two weeks in New York last summer.',
            options: ['あ、spend', 'い、spent', 'う、spending'],
            answer: 2
        },
        {
            title: '次の気体のうち、水上置換法では集めることができないものはどれですか?',
            options: ['あ、H2', 'い、O2', 'う、NH3'],
            answer: 3
        },
        {
            title: '日本には何都道府県あるでしょうか？',
            options: ['あ、48', 'い、47', 'う、46'],
            answer: 2
        }
    ],
    '3': [
        {
            title: '【相場】の正しい読み方は？',
            options: ['あ、あいば', 'い、そうば', 'う、あいじょう'],
            answer: 2
        },
        {
            title: '次の数字のうち、素数はどれですか?',
            options: ['あ、2007', 'い、2011', 'う、2013'],
            answer: 2
        },
        {
            title: '【鹿（しか）】って英語で何て言う？',
            options: ['あ、deer', 'い、lamb', 'う、bear'],
            answer: 1
        },
        {
            title: 'フッ化水素は？',
            options: ['あ、NO2', 'い、SF', 'う、HF'],
            answer: 3
        },
        {
            title: '殷の国は何文字をつくったか？',
            options: ['あ、蹶起文字', 'い、南北文字', 'う、甲骨文'],
            answer: 3
        }
    ],
    '4': [
        {
            title: '【鰍】の正しい読み方は？',
            options: ['あ、カジカ', 'い、ヒラメ', 'う、クジラ'],
            answer: 1
        },
        {
            title: '32a^2 b/4ab =？？？',
            options: ['あ、8a', 'い、8ab', 'う、8'],
            answer: 1
        },
        {
            title: 'The saying says，”There is nothing (???) home. ',
            options: ['あ、in', 'い、like', 'う、take'],
            answer: 2
        },
        {
            title: '哺乳類の体は何で覆われている？',
            options: ['あ、羽根', 'い、毛', 'う、うろこ'],
            answer: 2
        },
        {
            title: '次の岩石のうち等粒状組織が見られるものを１つ選びなさい',
            options: ['あ、火山岩', 'い、石灰岩', 'う、花崗岩'],
            answer: 3
        }
    ],
    '5': [
        {
            title: '三月の時候の挨拶言葉はどれですか？',
            options: ['あ、春寒の候', 'い、早春の候', 'う、春暖の候'],
            answer: 2
        },
        {
            title: '一辺の長さがａｃｍの正方形のまわりの長さは何ｃｍでしょう？ａを用いて表そう。',
            options: ['あ、4a', 'い、2a', 'う、8a'],
            answer: 1
        },
        {
            title:
        '先週、私は雪で覆われたあの山に登りました。 <br>Last week I climbed that mountain (???) with snow.',
            options: ['あ、cover', 'い、covered', 'う、covering'],
            answer: 2
        },
        {
            title: '炎の温度が一番高いのは、何色でしょうか？',
            options: ['あ、赤', 'い、オレンジ', 'う、青'],
            answer: 3
        },
        {
            title:
        '中国、Ａ~Ｄの国名を古い順に並べたとき、正しいものを１つ選びなさい：Ａ唐 Ｂ秦 Ｃ元 Ｄ清',
            options: ['あ、BADC', 'い、ACBD', 'う、BACD'],
            answer: 3
        }
    ],
    '6': [
        {
            title: '【颪】の正しい読み方は？',
            options: ['あ、つむじ', 'い、おろし', 'う、かぜ'],
            answer: 2
        },
        {
            title: '虹の色X嵐の人数＝？？？',
            options: ['あ、にじゅうご', 'い、三十五', 'う、42'],
            answer: 2
        },
        {
            title: '訳せ。confident',
            options: ['あ、自信がある', 'い、泣き止む', 'う、不安がある'],
            answer: 1
        },
        {
            title: 'カエルの呼吸は？',
            options: ['あ、えら呼吸', 'い、ビオー呼吸', 'う、肺呼吸'],
            answer: 3
        },
        {
            title: 'ヨーロッパで一番高い山は？',
            options: ['あ、モンブラン山', 'い、マッターホルン山', 'う、エルブルース山'],
            answer: 3
        }
    ],
    '7': [
        {
            title: '【春夏秋冬】この名字の正しい読み方は？',
            options: ['あ、ひととせ', 'い、しゅんかしゅうとう', 'う、しゅんとう'],
            answer: 1
        },
        {
            title: '師走÷弥生+神無月＝？',
            options: ['あ、12', 'い、13', 'う、14'],
            answer: 3
        },
        {
            title: '訳せ。Killing two birds with one stone',
            options: ['あ、一石二鳥', 'い、日進月歩', 'う、七転八起'],
            answer: 1
        },
        {
            title: '鉄の融点は？',
            options: ['あ、1630', 'い、1530', 'う、1430'],
            answer: 2
        },
        {
            title: '豊臣秀吉が最初に城主となったのはどこですか？',
            options: ['あ、今浜城', 'い、大阪城', 'う、姫路城'],
            answer: 1
        }
    ],
    '8': [
        {
            title: '「楓橋夜泊」の作者名は？',
            options: ['あ、張継', 'い、李白', 'う、白居易'],
            answer: 1
        },
        {
            title:
        '少女は車を運転して家から隣町までの距離を往復した。行きは40km、帰りは60km。少女の車の平均時速は？',
            options: ['あ、50', 'い、48', 'う、45'],
            answer: 2
        },
        {
            title: '訳せ。Never better',
            options: ['あ、最悪', 'い、最新', 'う、最高'],
            answer: 3
        },
        {
            title: '地球に最も近い惑星は？',
            options: ['あ、金星', 'い、火星', 'う、太陽'],
            answer: 1
        },
        {
            title: '日本の自然遺産に当てはまらないのはどれでしょう？',
            options: ['あ、白神山地', 'い、知床', 'う、富士山'],
            answer: 3
        }
    ],
    '9': [
        {
            title: '古今和歌集が成立したのはいつ頃か？',
            options: ['あ、12世紀前半', 'い、11世紀前半', 'う、10世紀前半'],
            answer: 3
        },
        {
            title: '□に入る数字を答えなさい　1 2 3 4 6 9 12 □ 36',
            options: ['あ、15', 'い、18', 'う、20'],
            answer: 2
        },
        {
            title: '次のうちに和製英語ではないのはどれでしょうか？',
            options: ['あ、コンビニエンスストア', 'い、オードバイ', 'う、ガソリンスタンド'],
            answer: 1
        },
        {
            title: '金、銀、鉄のうちに密度が最も小さいのは？',
            options: ['あ、金', 'い、銀', 'う、鉄'],
            answer: 3
        },
        {
            title: 'ガソリン平均価格が最も高い都道府県は？',
            options: ['あ、長崎県', 'い、沖縄県', 'う、鹿児島県'],
            answer: 1
        }
    ]
};
export const RESULT = {
    '1000': 'バカバカしいあなたも可愛いね！勉強頑張りましょう！',
    '1020': '残念、不合格です。しっかり勉強してもう一回チャレンジしよう！',
    '1040': '残念、不合格です。しっかり勉強してもう一回チャレンジしよう！',
    '1060': '合格おめでとう！もうちょっと頑張れば満点だよ！',
    '1080': '合格おめでとう！もうちょっと頑張れば満点だよ！',
    '1100': '完璧だ！このレベルの優等生だ！もっと上に進もう！',
    '2000': 'バカバカしいあなたも可愛いね！勉強頑張りましょう！',
    '2020': '残念、不合格です。しっかり勉強してもう一回チャレンジしよう！',
    '2040': '残念、不合格です。しっかり勉強してもう一回チャレンジしよう！',
    '2060': '合格おめでとう！もうちょっと頑張れば満点だよ！',
    '2080': '合格おめでとう！もうちょっと頑張れば満点だよ！',
    '2100': '完璧だ！このレベルの優等生だ！もっと上に進もう！',
    '3000': '天才かバカかよく分からないorz',
    '3020': '残念、不合格です。さすがに難しいですね。しっかり勉強してもう一回チャレンジしよう！',
    '3040': '残念、不合格です。さすがに難しいですね。しっかり勉強してもう一回チャレンジしよう！',
    '3060': 'この賢さは90％の人より上回っているよ〜',
    '3080': 'この賢さは90％の人より上回っているよ〜',
    '3100': '東大レベルの天才だ！ドッキちゃんが憧れの人はあなただろう！'
};
